// extracted by mini-css-extract-plugin
module.exports = {"editor":"main_editor__3H2Ci"};